import { LinkProps as NextLinkPropsBase } from 'next/link';

export enum Underline {
  none,
  hover,
  always,
}

export type LinkProps = {
  underline?: Underline;
  classes?: string;
  showCursorPointer?: boolean;
  redirectStart?: boolean;
  href?: string;
  ariaLabel?: string;
  target?: '_blank' | '_self';
  rel?: string;
  onClick?: any;
  onContextMenu?: any;
};

export type NextLinkProps = LinkProps & NextLinkPropsBase;
